<template lang="pug">
  .redButton
    img(src='/img/red-button.png')
    
</template>

<script>
export default {
  name: 'redButton',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .redButton{
    width:200px;
    // height:400px;
    position:absolute;
    bottom:10px;
    right:5%;
    overflow:hidden;
    opacity:.4;
    // z-index: -1;
    img{
      width:100%;
    }
  }
  @media(max-width:760px){
    .redButton{
      // display:none;
      // opacity:.4;
      width:20%;
    }
  }
</style>
